import { render, staticRenderFns } from "./InitializeLicenses.vue?vue&type=template&id=4bcb8809&scoped=true&"
import script from "./InitializeLicenses.vue?vue&type=script&lang=js&"
export * from "./InitializeLicenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcb8809",
  null
  
)

export default component.exports